import { PropertyManagementSystem } from "shared/types/partner";

/**
 * PMS providers that support syncing a single property or unit by ID.
 * Detail pages will only show the sync button if the partner's PMS is in this list.
 */
export const SingleSyncPropertyManagementSystems: PropertyManagementSystem[] = [
  PropertyManagementSystem.Propertyware
];
